import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { auth } from './firebase'; // Ensure auth is imported
import './Dashboard.css';

const sections = [
  { id: 'onboarding', title: 'MY PROFILE', color: '#007AFF', desc: 'share about yourself and help our algorithm do the AI magic thingy' },
  { id: 'inout', title: 'IN / OUT', color: '#34C759', desc: 'like doomscrolling is an OUT for 2026 ‼️' },
  { id: 'mylist', title: '2026 BUCKET LIST', color: '#5856D6', desc: '2026 is literally my year 🧘🏼‍♂️' },
  { id: 'manifestations', title: '2026 VISION BOARD', color: '#FF2D55', desc: 'I am good. I am great😌.' },
  { id: 'groupslist', title: 'FRIEND-LIST', color: '#e28cd4ff', desc: 'like Pondy trip with my bbg🎀' },
  { id: 'aura', title: 'AURA CALC', color: '#FF9500', desc: 'hope you are not in generational aura debt🙏🏻' },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth.currentUser;
  const uuid = user ? user.uid : 'guest';

  // Check if we are at the hub
  const isHub = location.pathname === `/dashboard/${uuid}`;

  const handleNav = (targetId) => {
    // Navigate to /{id}/{uuid} for everything except special routes
    navigate(`/${targetId}/${uuid}`);
  };

  return (
    <div className="dashboard-root">
      <header className="dashboard-header">
        <h1 className="elite-logo" onClick={() => navigate(`/dashboard/${uuid}`)}>
          o n e s t o p . <span>25</span>
        </h1>
       
      </header>

      <main className="content-stage">
        {isHub ? (
          <div className="hub-grid">
            {sections.map((s) => (
              <motion.div 
                key={s.id}
                whileHover={{ scale: 1.05, rotate: -2 }}
                whileTap={{ scale: 0.95 }}
                className="hub-card-elite"
                style={{ '--accent': s.color }}
                onClick={() => handleNav(s.id)}
              >
                <div className="card-top-accent" />
                <div className="card-inner">
                  <span className="card-tag">{s.id}</span>
                  <h2 className="card-title">{s.title}</h2>
                  <p className="card-desc">{s.desc}</p>
                </div>
                <div className="card-footer-arrow">→</div>
              </motion.div>
            ))}
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}